export const config = {
  app: {
    name: process.env.NEXT_PUBLIC_SITE_NAME || "",
    defaultLocale: process.env.NEXT_PUBLIC_DEFAULT_LOCALE || "pt-BR",
    url: process.env.NEXT_PUBLIC_BASE_URL || "",
  },
  google: {
    analytics: process.env.NEXT_PUBLIC_GA_TRACK_ID || "",
    maps: process.env.NEXT_PUBLIC_GOOGLE_MAPS || "",
  },
  cockpit: {
    url: process.env.NEXT_PUBLIC_COCKPIT_URL || "",
  },
  menu: [
    {
      title: "Conheça",
      href: "/#conheca",
    },
    {
      title: "Cabo Branco",
      href: "/#cabo-branco",
    },
    {
      title: "Diferenciais",
      href: "/#diferenciais",
    },
    {
      title: "Perspectivas",
      href: "/#perspectivas",
    },
    {
      title: "Plantas e Tipologias",
      href: "/#plantas-e-tipologias",
    },
    {
      title: "Quero saber mais",
      href: "/#tenho-interesse",
    },
  ],
  contacts: {
    email: "",
    phone: "",
  },
  location: {
    address:
      "Av. Manoel Cavalcante de Souza, 344, Cabo Branco, João Pessoa, PB, 58045-090",
    lat: -7.1222685,
    lng: -34.8277568,
  },
  social: [
    {
      title: "Instagram",
      href: "https://instagram.com/moreiraeruffos",
    },
    {
      title: "Facebook",
      href: "https://facebook.com/MoreiraERuffos",
    },
    {
      title: "YouTube",
      href: "https://www.youtube.com/@moreiraruffos3461",
    },
  ],
};
